import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { MapContainer, TileLayer, Polyline, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from 'leaflet';
import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';


let DefaultIcon = L.icon({
    iconUrl: icon,
    shadowUrl: iconShadow,
    iconSize: [25, 41],
    iconAnchor: [12, 41]
});

L.Marker.prototype.options.icon = DefaultIcon;
const DriverManifestView = () => {
  const { routeId } = useParams(); // Gets '30-03-2026-driver-1' from URL
  const [stops, setStops] = useState([]);
  const [polyline, setPolyline] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadRoute = async () => {
      try {
        // Fetch from your Render/MongoDB backend
        // Using a relative path "/" works best for Render/Heroku deployments
        const res = await fetch(`/api/public-routes/${routeId}`); 
        
        if (!res.ok) throw new Error("Route not found on server");
        
        const data = await res.json();
        
        // Match the data structure from your MongoDB
        setStops(data.stops || []);
        setPolyline(data.polyline || []);
      } catch (err) {
        console.error("Failed to load driver route", err);
      } finally {
        setLoading(false);
      }
    };
    if (routeId) {
      loadRoute();
    }
  }, [routeId]);

  const openInMaps = (address) => {
  if (!address) {
    // If it's still missing, we can alert the driver
    alert("Address string not found in manifest");
    return;
  }
  const encoded = encodeURIComponent(address);
  window.open(`https://www.google.com/maps/search/?api=1&query=${encoded}`, "_blank");
};
const openInWaze = (address) => {
  const encoded = encodeURIComponent(address);
  // This triggers the Waze app on iPhone or Android
  window.open(`https://waze.com/ul?q=${encoded}&navigate=yes`, "_blank");
};

  if (loading) return <div className="p-5 text-center fw-bold">⏳ Loading Sunday Route...</div>;
  if (stops.length === 0) return <div className="p-5 text-center text-danger">⚠️ Route Not Found.</div>;

  return (
    <div className="driver-view" style={{ backgroundColor: "#f8f9fa", minHeight: "100vh" }}>
      {/* Header - High Visibility */}
      <div className="bg-dark text-white p-3 shadow-sm sticky-top">
        <h2 className="m-0 h4">🚛 {routeId.includes('driver-1') ? 'Local Route' : 'City Route'}</h2>
        <small className="text-secondary">{stops.length} Deliveries • {new Date().toLocaleDateString()}</small>
      </div>

      {/* Map Section - Fixed height for mobile */}
      <div style={{ height: "250px", width: "100%", borderBottom: "2px solid #dee2e6" }}>
        <MapContainer center={[45.4913, -73.8197]} zoom={11} style={{ height: "100%" }}>
         <TileLayer
  attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
/>
          {stops.map((stop, i) => (
            <Marker key={i} position={[stop.lat, stop.lng]}>
        <Popup>
          <strong>Stop {i + 1}: {stop.name}</strong><br />
          {stop.fullAddress}
        </Popup>
      </Marker>
          ))}
          <Polyline positions={polyline} color="blue" />
        </MapContainer>
      </div>

      {/* Manifest List - Huge buttons for thumbs */}
      <div className="p-2">
        {stops.map((stop, index) => (
          <div key={index} className="card mb-3 shadow-sm border-0">
            <div className="card-body d-flex align-items-center p-3">
              {/* Stop Number Circle */}
              <div className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center me-3" 
                   style={{ width: "45px", height: "45px", minWidth: "45px", fontSize: "1.2rem", fontWeight: "bold" }}>
                {index + 1}
              </div>

              <div className="flex-grow-1">
                <h5 className="mb-0 fw-bold">{stop.name}</h5>
                <p className="text-muted small mb-2">{stop.fullAddress}</p>
                {stop.specialNotes && (
                  <div className="badge bg-warning text-dark text-wrap mb-2 d-block text-start">
                    ⚠️ {stop.specialNotes}
                  </div>
                )}
                
                {/* BIG NAVIGATE BUTTON */}
                <div className="d-flex gap-2">
  {/* Google Maps Button */}
  <button 
    onClick={() => openInMaps(stop.fullAddress)}
    className="btn btn-success flex-grow-1 py-3 fw-bold shadow-sm d-flex align-items-center justify-content-center gap-2"
    style={{ fontSize: "1rem" }}
  >
    📍 GOOGLE
  </button>

  {/* Waze Button - This uses the 'openInWaze' you just declared */}
  <button 
    onClick={() => openInWaze(stop.fullAddress)}
    className="btn btn-info text-white flex-grow-1 py-3 fw-bold shadow-sm d-flex align-items-center justify-content-center gap-2"
    style={{ fontSize: "1rem", backgroundColor: "#33ccff", border: "none" }}
  >
    🚙 WAZE
  </button>
</div>
              </div>
            </div>
          </div>
        ))}
      </div>
      
      {/* Safety spacing at bottom */}
      <div style={{ height: "50px" }}></div>
    </div>
  );
};

export default DriverManifestView;